import { useEffect, useState } from "react";
import { FunctionalIDChilds } from "./FunctionalIDChilds";
import { ButtonFuntionalID } from './ButtonFuntionalID';
import { FinanceService } from '../../../../core/services/FinanceService';
import { useDashboardStore } from "../../../pages/hooks/useDashboardStore";
import { _FunctionalID, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_md } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { FileInput } from "../../../theme/Component/FileInput";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Tree {
  id: number | null;
  edit?: boolean;
}
export const FunctionalID = ({ id, edit }: Tree) => {
  const service = new FinanceService();
  const _functionalID = useDataBean(_FunctionalID);

  const { setLoading } = useDashboardStore();
  const [lista, setLista] = useState([]);
  const [idchild, setIDchild] = useState(0);
  const modalFuncionario = useModal("Importar Funcionario", MODAL_md);
  const [file, setFile] = useState<any>({});

  useEffect(() => {
    getListatree(idchild);
    getFunctionalIDSeparator();
  }, []);

  const getListatree = (idArbol: any) => {
    setLoading(true);
    service.getTreeForFunctionalID(idArbol).subscribe((resp: any) => {
      setLoading(false);
      if (resp.DataBeanProperties.ObjectValue) {
        setLista(resp.DataBeanProperties.ObjectValue.Childs);
      }
    });
  };

  const getFunctionalIDSeparator = () => {
    service.getFunctionalIDSeparator().subscribe(
      (resp: any) => {
        let separador = resp.DataBeanProperties.ObjectValue;
        localStorage.setItem('separador', separador);
      }
    );
  }

  const cargarFuncionarios = () => {
    console.log(file);

    _functionalID.instance.importAccountToWorkGroup(_single.getAccountID(), file.Media, file.MediaContext).then(
      (resp: any) => {
        toast.success("Funcionarios cargados correctamente");
        _single.printOut(resp);
        modalFuncionario.close();

      }
    )

  }


  return (
    <>

      {edit &&
        <>
          {_single.canCreate() &&
            <div>
              <BasicButton icon="fa fa-upload" eventClick={() => { modalFuncionario.open() }}>Cargar Funcionarios</BasicButton>
              <hr />
            </div>
          }
          <ButtonFuntionalID
            id={0}
            bean={{}}
            updateEvent={() => { getListatree(id); }}
          />
        </>
      }
      <div className="row">
        <div className="col-md-12">
          <ul className="list-group">
            {lista.length > 0 &&
              lista.map((item: any) => {
                return (
                  <li className="list-group-item itemh" key={item.EnvolvedObject.DataBeanProperties.IDLn}>
                    {edit &&
                      <ButtonFuntionalID
                        id={item.EnvolvedObject.DataBeanProperties.IDLn}
                        bean={item.EnvolvedObject.DataBeanProperties}
                        updateEvent={() => { getListatree(id); }}
                      />
                    }
                    <strong className="cursor" onClick={() => {
                      setIDchild(item.EnvolvedObject.DataBeanProperties.IDLn);
                      localStorage.setItem('FuntionalID', JSON.stringify(item.EnvolvedObject.DataBeanProperties));
                    }}>
                      <strong style={{ marginLeft: '15px' }}>{item.EnvolvedObject.DataBeanProperties.FunctionalViewCode} </strong>
                      <small>{item.EnvolvedObject.DataBeanProperties.Name}</small>
                    </strong>
                    <span className="badge bg-success ms-1">{item.ChildrenCount}</span>
                    {idchild === item.EnvolvedObject.DataBeanProperties.IDLn &&
                      // renderSon(item.EnvolvedObject.DataBeanProperties.IDLn)
                      <FunctionalIDChilds edit={edit} idChild={idchild} />
                    }
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="col-md-12">
          <Modal modal={modalFuncionario.modal} updateModal={modalFuncionario.setModal} eventModal={cargarFuncionarios} onSubmitLabel="Cargar">
            <div className="row">
              <div className="col-md-12">
                <FileInput directory="temp" label="Plantilla" onCreate={(e) => { setFile(e) }} />
              </div>
              <div className="col-md-12">
                <strong>Columnas</strong><br />
                CODIGO_OFICINA | NOMBRE_OFICINA | CEDULA | NOMBRE | JEFE | OFICINA
              </div>
            </div>
          </Modal>
        </div>
      </div>

    </>
  );
};
